// extracted by mini-css-extract-plugin
export default {"tags":"tags_EO6yk","tagItem":"tagItem_oJlh8","addBtn":"addBtn___9_R"};